"use client"

import { Camera, Mic, MicOff, Video } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Toggle } from "@/components/ui/toggle"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useScreenCapture } from "./feedback-provider"

/** Кнопки «Скриншот», «Записать экран» и микрофон для любой формы с вложениями */
export function CaptureButtons({
  add,
  disabled,
  compact,
  className,
  testIdPrefix = "feedback",
}: {
  add: (files: File[]) => void
  disabled?: boolean
  /** Только иконки — для тесных строк действий */
  compact?: boolean
  className?: string
  testIdPrefix?: string
}) {
  const capture = useScreenCapture()
  if (!capture?.mode) return null
  const { mic, setMic } = capture
  const dom = capture.mode === "dom"
  const btn = cn("text-muted-foreground", compact && "px-2", className)

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={btn}
        onClick={() => capture.screenshot(add)}
        disabled={disabled || capture.active}
        title={dom ? "Снимок текущего экрана приложения" : "Снимок вкладки, окна или экрана"}
        aria-label="Скриншот"
        data-testid={`${testIdPrefix}-screenshot`}
      >
        <Camera />
        {!compact && "Скриншот"}
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={btn}
        onClick={() => capture.record(add)}
        disabled={disabled || capture.active}
        title={dom ? "Запись экрана приложения: форма закроется, остановить запись — на плашке" : "Запись вкладки, окна или экрана"}
        aria-label="Записать экран"
        data-testid={`${testIdPrefix}-record`}
      >
        <Video />
        {!compact && "Записать экран"}
      </Button>
      <Tooltip>
        <TooltipTrigger asChild>
          <Toggle size="sm" pressed={mic} onPressedChange={setMic} className="text-muted-foreground" aria-label="Записывать голос с микрофона" data-testid={`${testIdPrefix}-mic`}>
            {mic ? <Mic /> : <MicOff />}
          </Toggle>
        </TooltipTrigger>
        <TooltipContent side="top">{mic ? "Запись экрана с голосом — нажмите, чтобы выключить микрофон" : "Запись экрана без голоса — нажмите, чтобы включить микрофон"}</TooltipContent>
      </Tooltip>
    </>
  )
}
